import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from "../../../../../../_shared/components/kpi-widget/kpi-widget.component";
import { AccountFilterRequest } from '../../../../../../_shared/models/account-filter.model';
import { WorkOrderService } from '../../../services/work-order.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-overdue-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './overdue-widget.component.html',
  styleUrl: './overdue-widget.component.scss'
})
export class OverdueWidgetComponent extends BaseWidgetComponent {
  private errorHandlerService: ErrorHandlerService = inject(ErrorHandlerService);
  private workOrderService = inject(WorkOrderService);
  private transloco = inject(TranslocoService);

  public errorMessage: string = '';
  public hasError: boolean = false;
  public overduePercentageChange: any;
  override title = this.transloco.translate('workOrder.widgets.overdue');
  override isLoading: boolean;

  constructor() {
    super(inject(FilterService));
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    return await this.getOverdueKpiStats();
  }

  async getOverdueKpiStats() {
    try {
      this.isLoading = true;
      this.cancelSubject.next();
      const request: AccountFilterRequest = {
        accountIds: this.widgetFilter.accountIds
      };

      const response = await this.workOrderService.getOverDueOrdersStatsKpi(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.overduePercentageChange = response.data?.percentageChange ?? null;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    } finally {
      this.isLoading = false;
    }
  }

  public override formatValue(value: number): string {
    return `${value.toFixed(0)}`;
  }

  openBreakdownModal(): void { }
}